<template>
  <h2 :class="$style.title"><slot /></h2>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SectionTitle',
})
</script>

<style lang="scss" module>
.title {
  color: $color-text-and-object-high-emphasis;
  font-size: 22px;
  font-weight: bold;
  line-height: 40px;
  line-height: 1;
}
</style>
